@if (treeControl) {
  <div class="rvc-sidebar float-start">
    <div [ngClass]="{'sidebar-mobile-spacer': mobile}"></div>
    <nx-sidebar #sidebar [minWidth]="70" [ngClass]="{'overlay-on-mobile': mobile, 'translucent-sidebar': translucent}">
      <div class="menu-tree">
        <div class="d-flex justify-content-center align-items-center w-100 nx-margin-bottom-s logo">
          <img [ngStyle]="{width: sidebar.open ? '175px' : '35px'}"
            [src]="sidebar.open ? 'assets/img/RVC_Digital.png' : 'assets/img/rvc_ico.png'"
            alt="Brand Logo"
            role="none"
            />
          </div>
          <div class="scroll-shadow" [ngClass]="{'active-top-scroll-shadow': applyTopScrollShadow}"></div>
          <div class="menus" #menus (scroll)="onScroll()" (resize)="onScroll()">
            <nx-tree #treeComponent [dataSource]="dataSource" [treeControl]="treeControl" (resize)="onScroll()">
              <nx-tree-node *nxTreeNodeDef="let node">
                @if (sidebar.open) {
                  <a nxAction
                    nxTreeNodeActionItem
                    nxTreeNodePadding
                    [routerLink]="'/'+prefix+(node.prefix?'/'+node.prefix:'')+'/'+node.query"
                    routerLinkActive="is-selected"
                    type="button">
                    @if (node.icon) {
                      <nx-icon aria-label=""
                        nxActionIcon
                        [name]="node.icon"
                      ></nx-icon>
                    }
                    <ng-container> {{node.label | caption}}</ng-container>
                  </a>
                }
                @if (!sidebar.open) {
                  <a nxAction
                    nxTreeNodeActionItem
                    [routerLink]="'/'+prefix+(node.prefix?'/'+node.prefix:'')+'/'+node.query"
                    routerLinkActive="is-selected"
                    type="button">
                    @if (node.icon) {
                      <nx-icon aria-label=""
                        nxActionIcon
                        [name]="node.icon"
                      ></nx-icon>
                    }
                    <ng-container> {{node.label | caption}}</ng-container>
                  </a>
                }
              </nx-tree-node>
              <nx-tree-node *nxTreeNodeDef="let node; when: hasChild">
                <a nxAction
                  nxTreeNodeToggle
                  nxTreeNodeActionItem
                  expandable
                  [expanded]="treeControl.isExpanded(node)"
                  type="button">
                  @if (node.icon) {
                    <nx-icon aria-label=""
                      nxActionIcon
                    [name]="node.icon"></nx-icon>
                  }
                  <ng-container> {{node.label | caption}}</ng-container>
                </a>
              </nx-tree-node>
            </nx-tree>
          </div>
          <div class="scroll-shadow" [ngClass]="{'active-bottom-scroll-shadow': applyBottomScrollShadow}"></div>
          <div class="footer">
            <a nxAction type="button" [nxContextMenuTriggerFor]="menu" aria-label="Profile">
              <nx-icon nxActionIcon name="user-o"></nx-icon>
              <span class="fullname">{{authUser.lastName}} {{authUser.firstName}}</span><br>{{authUser.email}}
            </a>
            <a nxAction type="button" (click)="toggleSidebar()">
              <nx-icon nxActionIcon [name]="sidebar.open ? 'chevron-left' : 'chevron-right'"></nx-icon>
              {{'general.collapse-menu' | caption}}
            </a>
          </div>
        </div>
      </nx-sidebar>
    </div>
  }

  <nx-context-menu #menu="nxContextMenu">
    @if (authUser) {
      <a nxContextMenuItem type="button" (click)="logout()">
        <nx-icon aria-hidden="true" name="arrow-right-from-bracket"></nx-icon>
        {{'general.logout' | caption}}
      </a>
    }
  </nx-context-menu>
